import { useEffect, useRef } from "react";
import { FiLoader, FiX } from "react-icons/fi";

const CancelMembershipPopup = ({ endDate, busy, error, onClose, onConfirm }) => {
  const dialogRef = useRef(null);
  const date = endDate ? new Date(endDate) : null;
  const hasEndDate = date && Number.isFinite(date.getTime()) && date.getTime() > Date.now();

  useEffect(() => {
    const dialog = dialogRef.current;
    const previousFocus = document.activeElement;
    dialog.showModal();
    return () => {
      dialog.close();
      previousFocus?.focus();
    };
  }, []);

  return (
    <dialog ref={dialogRef} aria-labelledby="cancel-membership-title"
      aria-describedby="cancel-membership-description"
      onCancel={(event) => { event.preventDefault(); if (!busy) onClose(); }}
      className="m-auto w-[calc(100%-2rem)] max-w-md rounded-lg border border-gray-200 bg-white p-6 text-gray-950 shadow-xl backdrop:bg-black/40">
      <div className="flex items-center justify-between gap-4">
        <h2 id="cancel-membership-title" className="text-lg font-semibold">Cancel membership?</h2>
        <button type="button" onClick={onClose} disabled={busy} aria-label="Close cancellation popup" title="Close"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-gray-500 enabled:hover:bg-gray-100 disabled:cursor-not-allowed">
          <FiX aria-hidden="true" className="h-5 w-5" />
        </button>
      </div>
      <p id="cancel-membership-description" className="mt-4 text-sm leading-6 text-gray-600">
        {hasEndDate ? <>Cancellation of current membership will take effect on <time dateTime={date.toISOString()} className="font-semibold text-gray-950">{date.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</time>. Membership will continue until then.</>
          : "Cancellation will take effect immediately"}
      </p>
      {error && <p role="alert" className="mt-4 text-sm text-red-700">{error}</p>}
      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button type="button" autoFocus onClick={onClose} disabled={busy}
          className="flex h-11 items-center justify-center rounded-md border border-gray-300 px-4 text-sm font-semibold enabled:hover:bg-gray-50 disabled:cursor-not-allowed">Keep membership</button>
        <button type="button" onClick={onConfirm} disabled={busy} aria-busy={busy}
          aria-label={busy ? "Cancelling membership" : "Confirm cancellation"}
          className="flex h-11 min-w-44 items-center justify-center rounded-md bg-red-700 px-4 text-sm font-semibold text-white enabled:hover:bg-red-800 disabled:cursor-not-allowed">
          {busy ? <FiLoader aria-hidden="true" className="h-5 w-5 animate-spin" /> : "Confirm cancellation"}
        </button>
      </div>
    </dialog>
  );
};

export default CancelMembershipPopup;
